export const INVALID_TENANT_MODAL_CONFIG = {
	translationPath: 'showInvalidTenant',
	logoutTimer: 15000
};
